import React, { FC, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { Loader } from '../../components/Loader';
import useScriptLoader, { SCRIPTS } from '../../context/ScriptLoader/useScriptLoader';
import { useAuth } from '../../utils/hooks';

interface LogoutPageProps {
  loadingUser: boolean;
}

const LogoutPage: FC<LogoutPageProps> = ({ loadingUser }) => {
  const history = useHistory();
  const { logout, isAuthenticated, isLoading, isInitialized } = useAuth();
  const isUserComLoaded = useScriptLoader(SCRIPTS.USER_COM);

  useEffect(() => {
    const handleLogout = async () => {
      if (isInitialized && !isLoading && !loadingUser) {
        if (isAuthenticated) {
          if (isUserComLoaded && window?.UE?.resetAuth) {
            await window?.UE?.resetAuth({
              apiKey: process.env.REACT_APP_USERCOM_API_KEY,
            });
          }
          logout();
        } else {
          history.replace('/');
        }
      }
    };

    handleLogout();
  }, [
    isInitialized,
    isLoading,
    isAuthenticated,
    logout,
    history,
    loadingUser,
    isUserComLoaded,
  ]);

  return <Loader />;
};

export default LogoutPage;
